export default {
  hot_news: "紧急推送".toUpperCase(),
};
